<template>
	<div id="loading" v-bind:class="{ loading: loading }">
		<div>
			<img src="/images/loading.png">
			<p>{{ loadingText }}</p>
		</div>
	</div>
</template>

<script>
	import { mapState } from "vuex";

	export default {
		name: "Loading",
		computed: {
			...mapState([ "loading", "loadingText" ]),
		}
	}
</script>

<style scoped lang="scss">
	#loading {
		position: fixed;
		display: block;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0,0,0,0.5);
		z-index: 20000;
		cursor: wait;
		visibility: hidden;
		opacity: 0;
		transition: visibility 0s 0.15s, opacity 0.15s linear;

		div {
			position: absolute;
			margin: auto;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			width: 200px;
			height: 260px;

			img {
				animation: loading-rotate 2s infinite;
				-webkit-filter: drop-shadow(8px 8px 8px rgba(0,0,0,0.2));
			}

			p {
				color: white;
				font-size: 20px;
				text-align: center;
				margin-top: 20px;
			}
		}

		&.loading {
			visibility: visible;
			opacity: 1;
			transition: opacity 0.15s linear;
		}
	}

	@keyframes loading-rotate {
		0% {
			transform: scale(0.8);
		}
		30% {
			transform: scale(0.95);
		}
		40% {
			transform: scale(1);
		}
		80% {
			transform: scale(0.8);
		}
		81% {
			transform: rotate(0deg) scale(0.8);
		}
		100% {
			transform: rotate(360deg) scale(0.8);
		}
	}
</style>
